// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__gTAen","sizeS":"style_size-s__W6Z2i","sizeM":"style_size-m__Oi0IR","sizeL":"style_size-l__vcwSy","disabled":"style_disabled__pZcBA"};